import { ref } from 'vue';

// This setting controls what an agent sees. Incoming translation is still
// generated once for the shared conversation and stays visible to enabled agents.
export const disabledGptAgentIds = ref([]);
let started = false;

export function startGptPermissionsRefresh() {
  if (started) return;
  started = true;
  const refresh = async () => {
    try {
      const response = await fetch('/gpt-translator/api/agent-permissions', {
        credentials: 'same-origin',
        cache: 'no-store',
      });
      if (!response.ok) throw new Error('GPT permissions unavailable');
      const value = await response.json();
      disabledGptAgentIds.value = Array.isArray(value.disabled_agent_ids)
        ? value.disabled_agent_ids.map(String)
        : [];
    } catch {
      // Preserve the last known permissions if the translator is temporarily down.
    }
  };
  refresh();
  setInterval(refresh, 15000);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh();
  });
}

export function isGptPrivateNote(message) {
  if (!message?.private) return false;
  const text = String(message.content || '').trim();
  return /^(?:【(?:中译｜|GPT中文翻译|GPT发送记录|发送记录｜|发送记录】|GPT处理失败)|\[(?:Chinese Translation|Translation|Sending Record|Suggestion)(?:\s*\|[^\]]*)?\])/i.test(text);
}

export function shouldHideGptNote(message, userId, disabledIds) {
  return disabledIds.some(id => String(id) === String(userId)) &&
    isGptPrivateNote(message);
}
